// extracted by mini-css-extract-plugin
export default {"Button":"style_Button__IOPUn","outline":"style_outline__Sla6L","solid":"style_solid__3EAnb"};